import { render, staticRenderFns } from "./ConciliacaoFaturamentoItensHeader.vue?vue&type=template&id=0b83571c"
import script from "./ConciliacaoFaturamentoItensHeader.vue?vue&type=script&lang=js"
export * from "./ConciliacaoFaturamentoItensHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports